import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class DamagedZoneService {
  static LOAD_TYPES = "/api/load_types/select";

  static getAllDamagedZones = async (params: any) => {
    try {
      return await Http.get(API_URLs.settings.damagedZone, params);
    } catch (error) {
      return error;
    }
  };
  static getOneDamagedZone = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.settings.damagedZone, id);
    } catch (error) {
      return error;
    }
  };
  static createDamagedZone = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.damagedZone, data);
    } catch (error) {
      return error;
    }
  };

  static updateDamagedZone = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.damagedZone, data);
    } catch (error) {
      return error;
    }
  };

  static deleteDamagedZone = async (id: number) => {
    try {
      return await Http.delete(API_URLs.settings.damagedZone, id);
    } catch (error) {
      return error;
    }
  };

  static getAllLoadTypes = async (params?: any) => {
    try {
      return await Http.get(this.LOAD_TYPES, params);
    } catch (error) {
      return error;
    }
  };
}
